// extracted by mini-css-extract-plugin
export default {"wrapper":"ChangesOverTimeTitle_wrapper__aEFJk","title":"ChangesOverTimeTitle_title__tFO0x"};